class CustomDropdown extends HTMLElement {
    constructor() {
        super()
        this.selectElement = this.querySelector('select');
        this.list = document.createElement('ul');
        this.styledSelect = document.createElement('div'); 
        this.wrapper = document.createElement('div');

        this.init()

        document.addEventListener('click', () => {
            this.styledSelect.classList.remove('active');
            this.list.style.display = 'none';
        });

    }

    init() {
        let numberOfOptions = this.selectElement.children.length;
        let optionName = this.selectElement.dataset.optionName;
        let optionPosition = this.selectElement.dataset.optionPosition;
        if(optionName) {
            optionName = optionName + ' : '
        } else {
            optionName = ''
        }
        this.selectElement.classList.add('select-hidden');
        this.setAttribute('data-option-position', optionPosition)

        this.wrapper.className = 'select';
        this.selectElement.parentNode.insertBefore(this.wrapper, this.selectElement);
        this.wrapper.appendChild(this.selectElement);

        this.styledSelect.className = 'select-styled';
        this.styledSelect.innerHTML = `<div class="custom-select-label">${optionName + this.selectElement.querySelector("option[selected]").textContent}</div>`;
        this.wrapper.appendChild(this.styledSelect);

        this.list.className = 'select-options';
        this.wrapper.appendChild(this.list);

        for (let i = 0; i < numberOfOptions; i++) {
            let listItem = document.createElement('li');
            listItem.textContent = this.selectElement.children[i].textContent;
            listItem.setAttribute('rel', this.selectElement.children[i].value);
            listItem.setAttribute('data-option-position', optionPosition);
            listItem.setAttribute('data-option-value', this.selectElement.children[i].value);
            if(this.selectElement.children[i].hasAttribute('disabled')) {
                listItem.setAttribute('disabled', true);
            }
            this.list.appendChild(listItem);

            if (this.selectElement.children[i].selected) {
                listItem.classList.add('is-selected');
            }
        }

        let listItems = this.list.children;

        this.styledSelect.addEventListener('click', (e) => {
            e.stopPropagation();
            document.querySelectorAll('div.select-styled.active').forEach((activeStyledSelect) => {
                if (activeStyledSelect !== this.styledSelect) {
                    activeStyledSelect.classList.remove('active');
                    activeStyledSelect.nextElementSibling.style.display = 'none';
                }
            });
            this.styledSelect.classList.toggle('active');
            this.list.style.display = this.styledSelect.classList.contains('active') ? 'block' : 'none';
        });

        this.styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
                        <path d="M1 1L7 5L13 1" stroke="black"/>
                    </svg></div>`);

        Array.from(listItems).forEach((listItem) => {
            listItem.addEventListener('click', (e) => {
                e.stopPropagation();
                let optionName = this.styledSelect.closest('.select').querySelector('select').dataset.optionName
                if(optionName) {
                    optionName = optionName + ' : '
                } else {
                    optionName=''
                }
                this.styledSelect.innerHTML = `<div class="custom-select-label">${optionName +  listItem.textContent}</div>`;
                
                this.styledSelect.classList.remove('active');
                this.selectElement.value = listItem.getAttribute('rel');
                this.list.querySelector('li.is-selected').classList.remove('is-selected');
                listItem.classList.add('is-selected');
                this.list.style.display = 'none';
                // document.dispatchEvent(new CustomEvent('selectPDPOptions:change', { detail: this.selectElement }));
                this.styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
                        <path d="M1 1L7 5L13 1" stroke="black"/>
                    </svg>
                </div>`);
                this.selectElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}))
            });

        });
    }
}

customElements.define('custom-dropdown', CustomDropdown)